import _typeof from "@babel/runtime/helpers/typeof";
import _inherits from "@babel/runtime/helpers/inherits";
import _setPrototypeOf from "@babel/runtime/helpers/setPrototypeOf";
function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(e, r) { return new BabelRegExp(e, void 0, r); }; var e = RegExp.prototype, r = new WeakMap(); function BabelRegExp(e, t, p) { var o = RegExp(e, t); return r.set(o, p || r.get(e)), _setPrototypeOf(o, BabelRegExp.prototype); } function buildGroups(e, t) { var p = r.get(t); return Object.keys(p).reduce(function (r, t) { var o = p[t]; if ("number" == typeof o) r[t] = e[o];else { for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length;) i++; r[t] = e[o[i]]; } return r; }, Object.create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (r) { var t = e.exec.call(this, r); if (t) { t.groups = buildGroups(t, this); var p = t.indices; p && (p.groups = buildGroups(p, this)); } return t; }, BabelRegExp.prototype[Symbol.replace] = function (t, p) { if ("string" == typeof p) { var o = r.get(this); return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)(>|$)/g, function (e, r, t) { if ("" === t) return e; var p = o[r]; return Array.isArray(p) ? "$" + p.join("$") : "number" == typeof p ? "$" + p : ""; })); } if ("function" == typeof p) { var i = this; return e[Symbol.replace].call(this, t, function () { var e = arguments; return "object" != _typeof(e[e.length - 1]) && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e); }); } return e[Symbol.replace].call(this, t, p); }, _wrapRegExp.apply(this, arguments); }
import isEqual from 'lodash/isEqual';
export default function (md, idMap, featureToggles, htmlConversionCounts, markdownPlusAttributeStatus) {
  var rule = md.inline.ruler.before('text', 'custom', function (state, silent) {
    var _match$groups, _match$groups2, _match$groups3, _match$groups4;
    var start = state.pos;
    var origSrc = state.src;
    var match;
    if (featureToggles.markdownPlusAttributeTest) {
      match = state.src.slice(start).match(
      /*#__PURE__*/
      /**
       * Matches the following:
       * <custom data-type="smartlink" data-id="123">content</custom>
       * <custom data-id="123">content</custom>
       * <custom data-type="emoji">content</custom>
       * <custom>content</custom>
       * <custom data-type="status" data-id="id-0" data-attrs='{"text":"test","color":"neutral"}'>test</custom>
       */
      // Ignored via go/ees005
      // eslint-disable-next-line require-unicode-regexp
      _wrapRegExp(/<custom(?:\s+data-type="([^"]*)")?(?:\s+data-id="([^"]*)")?(?:\s+data-attrs="(\{.*?\})")?\s*>(.*?)<\/custom>/, {
        dataType: 1,
        dataId: 2,
        dataAttrs: 3,
        dataContent: 4
      }));
    } else {
      match = state.src.slice(start).match(
      /*#__PURE__*/
      /**
       * Matches the following:
       * <custom data-type="smartlink" data-id="123">content</custom>
       * <custom data-id="123">content</custom>
       * <custom data-type="emoji">content</custom>
       * <custom>content</custom>
       */
      // Ignored via go/ees005
      // eslint-disable-next-line require-unicode-regexp
      _wrapRegExp(/<custom(\sdata-(type|id)="(.*?)")?(\sdata-(type|id)="(.*?)")?>(.*?)<\/custom>/, {
        dataType: 3,
        dataId: 6,
        dataContent: 7
      }));
    }
    if (!match) {
      return false;
    }
    var tagLength = match[0].length;
    var beforeTag = state.src.slice(start, state.src.indexOf(match[0]));
    var dataType = (_match$groups = match.groups) === null || _match$groups === void 0 ? void 0 : _match$groups.dataType;
    var dataId = (_match$groups2 = match.groups) === null || _match$groups2 === void 0 ? void 0 : _match$groups2.dataId;
    var dataAttrs = (_match$groups3 = match.groups) === null || _match$groups3 === void 0 ? void 0 : _match$groups3.dataAttrs;
    var dataContent = (_match$groups4 = match.groups) === null || _match$groups4 === void 0 ? void 0 : _match$groups4.dataContent;
    var afterTag = state.src.slice(start + beforeTag.length + tagLength);
    function mapCustomDataTypeToNodeType(customDataType) {
      switch (customDataType) {
        case 'smartlink':
          return 'inlineCard';
        case 'date':
        case 'emoji':
        case 'status':
        case 'mention':
        case 'placeholder':
          return customDataType;
        // Just move below case alongside mention above to remove markdownPlusExtensions FF.
        case 'inlineExtension':
          return featureToggles.markdownPlusExtensions ? 'inlineExtension' : false;
        case 'mediaInline':
          return featureToggles.markdownPlusAddComplexNodes ? 'mediaInline' : false;
        default:
          return false;
      }
    }
    var customDataType = mapCustomDataTypeToNodeType(dataType);
    if (!silent) {
      var _idMap$dataId;
      // tokenize beforeTag
      if (beforeTag) {
        state.src = beforeTag;
        // @ts-ignore
        state.md.inline.tokenize(state, beforeTag);
      }
      if (dataId && idMap !== null && idMap !== void 0 && (_idMap$dataId = idMap[dataId]) !== null && _idMap$dataId !== void 0 && _idMap$dataId.attributes && customDataType) {
        htmlConversionCounts.htmlConvertedToNodes++;
        var customDataToken = state.push(customDataType, '', 0);
        // @ts-ignore
        customDataToken.pmAttrs = idMap[dataId].attributes;
        if (featureToggles.markdownPlusAttributeTest && dataAttrs) {
          try {
            if (isEqual(idMap[dataId].attributes, JSON.parse(dataAttrs))) {
              markdownPlusAttributeStatus.push([customDataType, true]);
            } else {
              // We need to check this because when you type it calls this function multiple times and the first time its called the current text is not the same
              if (idMap[dataId].attributes.text === JSON.parse(dataAttrs).text) {
                markdownPlusAttributeStatus.push([customDataType, false]);
              }
            }
          } catch (e) {
            markdownPlusAttributeStatus.push([customDataType, false]);
          }
        }
      } else {
        htmlConversionCounts.htmlConvertedToFallbackNodes++;
        var textToken = state.push('text', '', 0);

        // If there is no data content we want to hide the custom tags as the AI has hallucinated something
        if (!dataContent) {
          textToken.content = '';
        } else {
          textToken.content = dataContent || match[0];
        }
      }
      if (afterTag) {
        state.src = afterTag;
        state.pos = 0;
        // @ts-ignore
        state.md.inline.tokenize(state, afterTag);
      }
    }
    state.src = origSrc;
    state.pos = start + state.src.length;
    return true;
  });
  return rule;
}